import * as constants from './constants';

// API
export const loadMetricsMachines = machineId => ({
  type: constants.LOAD_METRICS_MACHINES,
  machineId
});
